import { Actions, ActionTypes } from './actions';
import { SalesLocation } from '../../types/customers';
import { Product, ProductCatalog } from '../types';
import { Discount } from '../../types/discounts';

export interface State {
    isLoading: boolean;
    error: boolean;
    assets: {
        discountId: string;
        publicUrl: string;
    }[];
    locations: SalesLocation[] | undefined;
    productsCatalogs: ProductCatalog[] | undefined;
    products: Product[] | undefined;
    discount: Discount | undefined;
}

export const initialState: State = {
    isLoading: false,
    error: false,
    assets: [],
    locations: undefined,
    productsCatalogs: undefined,
    products: undefined,
    discount: undefined,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.CreateCampaign:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.CreateCampaignResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
            };

        case ActionTypes.CreateAsset:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.CreateAssetResponse:
            return {
                ...state,
                error: false,
            };

        case ActionTypes.RemoveAsset:
            return {
                ...state,
                assets: [...state.assets.filter((asset) => asset.discountId !== action.payload.discountId)],
            };

        case ActionTypes.UploadAssetResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
                assets: [
                    ...state.assets,
                    {
                        discountId: action.meta.cause.payload.discountId,
                        publicUrl: action.meta.cause.payload.publicUrl,
                    },
                ],
            };

        case ActionTypes.FetchLocationsResponse:
            return {
                ...state,
                locations: action.payload,
            };

        case ActionTypes.FetchProductsCatalogsResponse:
            return {
                ...state,
                productsCatalogs: action.payload,
            };

        case ActionTypes.FetchProductsResponse:
            return {
                ...state,
                products: action.payload,
            };

        case ActionTypes.FetchDiscount:
            return {
                ...state,
                discount: undefined,
                isLoading: true,
            };

        case ActionTypes.FetchDiscountResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
                discount: action.payload,
            };

        default:
            return state;
    }
}
